import { UserType } from 'api'

export namespace permissions {
  export const canEditNotifications: UserType[] = [UserType.OWNER, UserType.ADMIN, UserType.DEBUG]
  export const canViewNotifications: UserType[] = [UserType.OWNER, UserType.ADMIN, UserType.DEBUG, UserType.NORMAL]
}

export default permissions
